export enum TAG {
  USER = 'User',
  MEDIA_PLAN = 'MediaPlan',
  CHANNEL = 'Channel',
  CHANNELS_BUDGET = 'ChannelsBudget',
  CHANNEL_METRICS = 'ChannelMetrics',
  RATE_CARD = 'RateCard',
  RATE_CARD_OPTIONS = 'RateCardOptions',
  ADMIN = 'Admin',
  EU6_CALCULATOR = 'EU6Calculator',
  CALCULATOR_PACKAGE = 'CalculatorPackage',
  BOOKING = 'Booking'
}
